import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Spinner, Form, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import { getSurveys } from "../../redux/climalaboral/Encuestas/actions";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import UserHeadDetail from "../../components/UserHeadDetail";
import UserHeadDetailMenu from "../../components/UserHeadDetailMenu";

const ClimaEmployeeCheckList = (props) => {
  //Redux
  const dispatch = useDispatch();

  const userN = useSelector((store) => store.auth.username);

  const data = useSelector((store) => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(
    (store) => store.funcTabEmployeed.loadingFicha_Empleado
  );

  const dataEncuestas = useSelector((store) => store.survey.surveyList);
  const dataEncuestasLength = useSelector((store) => store.survey.surveyLength);
  const encuestasLoading = useSelector(
    (store) => store.survey.loadingSurveyList
  );

  useEffect(() => {
    dispatch(
      getFuncFichaEmpleado(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
  }, [dispatch, props.match.params.id, props.match.params.type]);

  useEffect(() => {
    if (data && data.id) {
      dispatch(getSurveys({ filter: userN }));
    }
  }, [dispatch, data, props.match.params.type]);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <UserHeadDetail data={data} type={props.match.params.type} />
              <div className="my-4">
                <UserHeadDetailMenu
                  id={props.match.params.id}
                  type={props.match.params.type}
                />
                <div className="mt-4 mb-3">
                  <div className="d-flex aling-items-center justify-content-between px-2">
                    <h5 className="font-weight-bold text-uppercase m-0">
                      <i
                        className="flex-wrap material-icons"
                        style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                      >
                        cloud
                      </i>
                      &nbsp;Clima Laboral
                    </h5>
                    <div>
                      <span className="text-muted mr-3">
                        <i className="material-icons">vpn_key</i> Código:{" "}
                        {data.codigo}
                      </span>
                      <span className="text-muted mr-3">
                        <i className="material-icons">timer</i> Antigüedad:{" "}
                        {parseInt(data.antiguedad_laboral) < 1
                          ? ` ${parseInt(data.antiguedad_laboral)} meses`
                          : ` ${parseInt(
                              parseInt(data.antiguedad_laboral) / 12
                            )} años`}
                        {Math.floor(
                          (parseInt(data.antiguedad_laboral) / 12 -
                            parseInt(parseInt(data.antiguedad_laboral) / 12)) *
                            12
                        ) > 0
                          ? ` ${Math.floor(
                              (parseInt(data.antiguedad_laboral) / 12 -
                                parseInt(
                                  parseInt(data.antiguedad_laboral) / 12
                                )) *
                                12
                            )} meses`
                          : null}
                      </span>
                      <span className="text-muted">
                        <i className="material-icons">moving</i>{" "}
                        {data.Relacion_Laboral_List
                          ? data.Relacion_Laboral_List[0].descripcion
                          : "No ingresado aún"}
                      </span>
                    </div>
                  </div>
                  <hr className="mb-3" />
                  {encuestasLoading ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : dataEncuestas.length === 0 ? (
                    <Alert className="my-4" variant="info">
                      Aún no tiene encuestas pendientes
                    </Alert>
                  ) : (
                    <Table striped>
                      <thead>
                        <tr>
                          <th>Encuesta</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataEncuestas.map((item) => (
                          <tr>
                            <td>{item.campaña_list.nombre_campaña}</td>
                            <td>
                              <Link
                                size="sm"
                                variant="link"
                                type="button"
                                to={`/encuestas/${item.cuestionario_list.id}/${item.id}/${item.campaña_list.id}`}
                              >
                                <i className="material-icons">edit</i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ClimaEmployeeCheckList;
